import React, {useState} from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NavbarModulo from '../../components/NavbarModulo';
import TablaDetalleVer from './NotaDebitoVer';
import TablaDetalleVerSVMovilidad from './NotaDebitoVerNDMovilidad';
import TablaDetalleVerHN from './NotaDebitoVerHN';
import TablaDetalleVerHNMovilidad from './NotaDebitoVerHNMovilidad';
import TablaDetalleVerNIC from './NotaDebitoVerNIC';
import TablaDetalleVerNICMovilidad from './NotaDebitoVerNIMovilidad';
import TablaDetalleVerCRI from './NotaDebitoVerCRI';
import TablaDetalleVerCRIMovilidad from './NotaDebitoVerCRIMovilidad';
import TablaDetalleVerPAN from './NotaDebitoVerPAN';
import TablaDetalleVerPANMovilidad from './NotaDebitoVerPANMovilidad';

import {
    renderField,
    AsyncSelectField,
    renderDayPickerB,
    renderCurrencyFloat,
    renderFilePickerB,
    SelectField,
    renderNumber
} from "../../Utils/renderField/renderField";

function NotaDebitoForm(props) {
    const {
        crear,
        modulo,
        lectura,
        detalleND,
        listarDistribuidor,
        periodoD,
        registroNotaDebito,
        setArchivo,
        setPeriodo,
        setPais,
        setIDPais
    } = props;

    const estilo = {
        overflow: "auto",
        height: "500px",

    };

    const editar = window.location.href.includes('editar');
    let titulo = 'Nueva nota débito';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver nota débito'
    }
    
    let ruta = window.location.href;
    let id_emp = ruta.split('/');

    const [periodo, setPeriodoD] = useState('');
    const [pais, setPaisD] = useState('');
    const [paisID, setPaisID] = useState('');

    const handleOnChangeDistribuidor = (e) => {
        setPeriodoD(periodoD);
        setPeriodo(periodoD);
        let pais_distribuidor = e.value.split('#');
        setPaisD(pais_distribuidor[1]);
        setPais(pais_distribuidor[2]);
        setIDPais(pais_distribuidor[3]);
        setPaisID(pais_distribuidor[3]);
    };

    const tipos = [
        {
            value: 'NDP',
            label: 'Planilla'
        },
        {
            value: 'NDC',
            label: 'Comisión'
        },
        {
            value: 'NDM',
            label: 'Movilidad'
        },
    ];
    
    return (
        <div>
            <NavbarModulo
                periodoD = {periodoD}
                modulo = {modulo}
                titulo = {titulo}
            />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        {(crear === false && editar === false) &&
                            <div className='row mb-2'>
                                <div className='col-8'>
                                    <Field
                                        name="nombre_distribuidor"
                                        placeholder="Distribuidor"
                                        component={renderField}
                                        className="form-control"
                                        msj="Distribuidor"
                                        disabled={disabled}
                                    />
                                </div>
                                <div className='col-4'>
                                    <Field
                                        name="pais"
                                        placeholder="Pais"
                                        component={renderField}
                                        className="form-control"
                                        msj="Pais"
                                        disabled={disabled}
                                    />
                                </div>
                            </div>
                        }
                        {(editar === true) &&
                            <div>
                                <div className='row mb-2'>
                                    <div className='col-8'>
                                        <Field
                                            name="nombre_distribuidor"
                                            placeholder="Distribuidor"
                                            component={renderField}
                                            className="form-control"
                                            msj="Distribuidor"
                                            disabled={disabled}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-8'>
                                        <Field
                                            name="distribuidor_mod"
                                            placeholder="Distribuidor..."
                                            className="form-control-find"
                                            component={AsyncSelectField}
                                            loadOptions={listarDistribuidor}
                                            msj="Distribuidor"
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        {(crear === true) &&
                            <div className='row mb-3'>
                                <div className='col-8'>
                                    <Field
                                        name="distribuidor"
                                        placeholder="Distribuidor..."
                                        className="form-control-find"
                                        component={AsyncSelectField}
                                        loadOptions={listarDistribuidor}
                                        onChange={(e, value) => {
                                            handleOnChangeDistribuidor(value)
                                        }}
                                        msj="Distribuidor"
                                    />
                                </div>
                                <div className='col-4'>
                                    <div className="form-floating">
                                        <input
                                            className = {classNames('form-control')}
                                            type="text"
                                            value = {pais}
                                            disabled = {true}
                                        />
                                        <label className='form-label'>Pais</label>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className='row mb-2'>
                            <div className='col-3'>
                                <Field
                                    name="fecha_registro"
                                    component={renderDayPickerB}
                                    msj="Fecha"
                                    disabled={disabled}
                                />
                            </div>
                            <div className='col-3'>
                                <Field
                                    name='numero'
                                    component={renderField}
                                    className="form-control"
                                    placeholder="Numero"
                                    disabled={disabled}
                                    msj="Numero"
                                />
                            </div>
                            <div className='col-4'>
                                <div className="form-floating">
                                    <Field
                                        name="tipo"
                                        options={tipos}
                                        disabled={disabled}
                                        crear={crear}
                                        dato={crear === true ? 0 : lectura.tipo_planilla}
                                        component={SelectField}
                                        className="form-select"
                                        msj="Tipo nota débito"
                                    />
                                </div>
                            </div>
                            {(crear === false && editar === false) &&
                                <div className='col-2'>
                                    <Field
                                        name="monto"
                                        placeholder="Total"
                                        className="form-control"
                                        component={renderCurrencyFloat}
                                        disabled={true}
                                        msj="Total"
                                    />
                                </div>
                            }
                        </div>
                        <div className='mb-2'>
                            <Field
                                name="descripcion"
                                placeholder="Referencia"
                                component={renderField}
                                className="form-control"
                                msj="Referencia"
                                disabled={disabled}
                            />
                        </div>
                        {(crear === true) &&
                            <div className='row'>
                                <div className='col-3'>
                                    <Field
                                        photo={''}
                                        setFile={setArchivo}
                                        name="archivo"
                                        component={renderFilePickerB}
                                    />
                                </div>
                            </div>          
                        }
                        {(crear === false && editar === false) && (lectura.codigo_pais === 'SLV' ) && (lectura.tipo_planilla === 'NDP' || lectura.tipo_planilla === 'NDC') &&
                            <div style={estilo}>
                                <TablaDetalleVer
                                    detalle={detalleND}
                                />
                            </div>
                        }
                        {(crear === false && editar === false) && (lectura.codigo_pais === 'SLV' ) && (lectura.tipo_planilla === 'NDM') &&
                            <div style={estilo}>
                                <TablaDetalleVerSVMovilidad
                                    detalle={detalleND}
                                />
                            </div>
                        }
                        {(crear === false && editar === false) && (lectura.codigo_pais === 'HND' ) && (lectura.tipo_planilla === 'NDP' || lectura.tipo_planilla === 'NDC') &&
                            <div style={estilo}>
                                <TablaDetalleVerHN
                                    detalle={detalleND}
                                />
                            </div>
                        }
                        {(crear === false && editar === false) && (lectura.codigo_pais === 'HND' ) && (lectura.tipo_planilla === 'NDM') &&
                            <div style={estilo}>
                                <TablaDetalleVerHNMovilidad
                                    detalle={detalleND}
                                />
                            </div>
                        }
                        {(crear === false && editar === false) && (lectura.codigo_pais === 'NIC' ) && (lectura.tipo_planilla === 'NDP' || lectura.tipo_planilla === 'NDC') &&
                            <div style={estilo}>
                                <TablaDetalleVerNIC
                                    detalle={detalleND}
                                />
                            </div>
                        }
                        {(crear === false && editar === false) && (lectura.codigo_pais === 'NIC' ) && (lectura.tipo_planilla === 'NDM') &&
                            <div style={estilo}>
                                <TablaDetalleVerNICMovilidad
                                    detalle={detalleND}
                                />
                            </div>
                        }
                        {(crear === false && editar === false) && (lectura.codigo_pais === 'CRI' ) && (lectura.tipo_planilla === 'NDP' || lectura.tipo_planilla === 'NDC') &&
                            <div style={estilo}>
                                <TablaDetalleVerCRI
                                    detalle={detalleND}
                                />
                            </div>
                        }
                        {(crear === false && editar === false) && (lectura.codigo_pais === 'CRI' ) && (lectura.tipo_planilla === 'NDM') &&
                            <div style={estilo}>
                                <TablaDetalleVerCRIMovilidad
                                    detalle={detalleND}
                                />
                            </div>
                        }
                        {(crear === false && editar === false) && (lectura.codigo_pais === 'PAN' ) && (lectura.tipo_planilla === 'NDP' || lectura.tipo_planilla === 'NDC') &&
                            <div style={estilo}>
                                <TablaDetalleVerPAN
                                    detalle={detalleND}
                                />
                            </div>
                        }
                        {(crear === false && editar === false) && (lectura.codigo_pais === 'PAN' ) && (lectura.tipo_planilla === 'NDM') &&
                            <div style={estilo}>
                                <TablaDetalleVerPANMovilidad
                                    detalle={detalleND}
                                />
                            </div>
                        }
                        <br/>
                        
                        <div className='d-flex flex-row mt-3'>
                            {(crear === true && editar === false) &&
                                <button
                                className='btn mr-2 mb-3 btn-primary'
                                onClick={() => {
                                    registroNotaDebito({}, [], periodo, pais, paisID);
                                }}
                                >
                                    Guardar
                                </button>
                            }
                            <a
                                href = {`/#/visitador_medico/${id_emp[5]}/nota_debito_planilla/${id_emp[7]}`}
                                className='btn btn-secondary mb-3'
                            >
                                Regresar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

NotaDebitoForm.propTypes = {
    crear: PropTypes.bool,
    lectura: PropTypes.object,
    editar: PropTypes.bool,
    bloqueo: PropTypes.bool,
    modulo: PropTypes.object,
    periodoD: PropTypes.object,
    datos: PropTypes.object,
};

export default reduxForm({
    form: 'FormNotaDebitoPlanillaVM',
})(NotaDebitoForm);
